import styled from '@mint-lib/styled';

import {
  Box,
  Skeleton,
  Table,
  TableBody,
  TableBodyCell,
  TableContainer,
  TableHead,
  TableHeaderCell,
  TableRow,
} from '@myn/mui';

const ROWS = [
  { id: 1, withAvatar: true },
  { id: 2, withAvatar: true },
  { id: 3, withAvatar: false },
  { id: 4, withAvatar: false },
  { id: 5, withAvatar: true },
  { id: 6, withAvatar: true },
  { id: 7, withAvatar: false },
  { id: 8, withAvatar: false },
  { id: 9, withAvatar: true },
  { id: 10, withAvatar: false },
];
const TableSkeleton = () => {
  return (
    <Box sx={{ position: 'relative' }}>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableHeaderCell width={40} sx={{ padding: 0 }}>
                <Box width={40} display="flex" justifyContent="center">
                  <Skeleton variant="circular" width={16} />
                </Box>
              </TableHeaderCell>
              <TableHeaderCell>
                <Skeleton variant="circular" width={16} />
                <Skeleton variant="rounded" width={224} />
              </TableHeaderCell>
              <TableHeaderCell>
                <Skeleton variant="rounded" width={168} />
              </TableHeaderCell>
              <TableHeaderCell>
                <Skeleton variant="rounded" width={168} />
              </TableHeaderCell>
              <TableHeaderCell>
                <Skeleton variant="rounded" width={168} />
              </TableHeaderCell>
              <TableHeaderCell>
                <Skeleton variant="rounded" width={168} />
              </TableHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TotalRow />
            {ROWS.map((row) => (
              <RowSkeleton key={row.id} withAvatar={row.withAvatar} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box
        sx={{
          position: 'absolute',
          width: 4,
          height: 484,
          top: 0,
          left: 320,
          zIndex: '99',
          background: (theme) => theme.palette.greyscale.grey20,
        }}
      />
    </Box>
  );
};

function TotalRow() {
  return (
    <TableRow>
      <TotalBodyCell />
      <TotalBodyCell />
      <TotalBodyCell />
      <TotalBodyCell />
      <TotalBodyCell />
      <TotalBodyCell />
    </TableRow>
  );
}

function RowSkeleton({ withAvatar }: { withAvatar?: boolean }) {
  return (
    <TableRow>
      <TableBodyCell sx={{ padding: 0 }}>
        <Box width={40} display="flex" justifyContent="center">
          {withAvatar ? <Skeleton variant="circular" width={16} /> : null}
        </Box>
      </TableBodyCell>
      <TableBodyCell>
        <Skeleton variant="rounded" width={248} />
      </TableBodyCell>
      <TableBodyCell>
        <Box display="flex" justifyContent="flex-end" width={168}>
          <Skeleton variant="rounded" width={84} />
        </Box>
      </TableBodyCell>
      <TableBodyCell>
        <Box display="flex" justifyContent="flex-end" width={168}>
          <Skeleton variant="rounded" width={84} />
        </Box>
      </TableBodyCell>
      <TableBodyCell>
        <Box display="flex" justifyContent="flex-end">
          <Skeleton variant="rounded" width={84} />
        </Box>
      </TableBodyCell>
      <TableBodyCell>
        <Box display="flex" justifyContent="flex-end">
          <Skeleton variant="rounded" width={84} />
        </Box>
      </TableBodyCell>
    </TableRow>
  );
}

const TotalBodyCell = styled(TableBodyCell)`
  background-color: ${({ theme }) => theme.palette.background.default};
`;

export default TableSkeleton;
